var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpBooksApiV5Request } from "./http-api-request.js";
export function createGroup(bookId, group, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/groups`, config).setMethod('POST').setPayload(group).fetch();
        return response.data;
    });
}
export function createGroups(bookId, payload, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const response = yield new HttpBooksApiV5Request(`${bookId}/groups/batch`, config).setMethod('POST').setPayload(payload).fetch();
        return ((_a = response.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
export function updateGroup(bookId, group, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/groups`, config).setMethod('PUT').setPayload(group).fetch();
        return response.data;
    });
}
export function deleteGroup(bookId, group, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/groups/${group.id}`, config).setMethod('DELETE').fetch();
        return response.data;
    });
}
export function getGroupsByAccountId(bookId, accountId, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        var response = yield new HttpBooksApiV5Request(`${bookId}/accounts/${accountId}/groups`, config).setMethod('GET').fetch();
        return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
export function getGroups(bookId, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/groups`, config).setMethod('GET').fetch();
        var groupsPlain = response.data;
        if (!(groupsPlain === null || groupsPlain === void 0 ? void 0 : groupsPlain.items)) {
            return [];
        }
        return groupsPlain.items;
    });
}
export function getGroup(bookId, idOrName, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/groups/${encodeURIComponent(idOrName)}`, config).setMethod('GET').fetch();
        return response.data;
    });
}
export function getAccounts(bookId, idOrName, config) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!idOrName) {
            return [];
        }
        var response = yield new HttpBooksApiV5Request(`${bookId}/groups/${encodeURIComponent(idOrName)}/accounts`, config).setMethod('GET').fetch();
        var accountsPlain = response.data;
        if (!(accountsPlain === null || accountsPlain === void 0 ? void 0 : accountsPlain.items)) {
            return [];
        }
        return accountsPlain.items;
    });
}
//# sourceMappingURL=group-service.js.map